import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'Which CAD and ERP systems do you support?',
  answer: 'We support OnShape, Fusion 360, SolidWorks, and can add support for other CAD systems upon request. For ERPs, we integrate with SAP, NetSuite, Oracle, Microsoft Dynamics, Thruline, Epicor, Infor, and 40+ other systems. Contact us to confirm compatibility with your specific setup.'
}, {
  question: 'How secure is my manufacturing data?',
  answer: 'Security is our top priority. We use enterprise-grade encryption (AES-256) for data at rest and in transit, SOC 2 Type II compliance, regular security audits, and role-based access controls. Your data never leaves your secure environment—we only facilitate the sync between your existing systems.'
}, {
  question: "What's the implementation time?",
  answer: 'Implementation typically takes 1-2 weeks depending on your system complexity. We start by reviewing your CAD system, ERP system, engineering change order processes, and bill of material management. Then we map your data fields and configure the automated sync. Our team guides you through every step.'
}, {
  question: 'Does this require IT involvement to set up?',
  answer: 'For basic setups, our team handles the technical configuration with minimal IT involvement. For enterprise deployments with custom security requirements or complex ERP configurations, we recommend involving your IT team. We provide dedicated onboarding support and work directly with your technical teams.'
}, {
  question: 'Can I cancel anytime?',
  answer: 'Yes, absolutely. All plans are flexible with no long-term lock-in contracts. You can cancel anytime from your account settings. Your data remains accessible for 30 days after cancellation for export purposes.'
}, {
  question: 'Do you offer dedicated support?',
  answer: 'Yes. Starter plans include email support with 24-hour response time. Professional plans get priority support with 4-hour response time. Enterprise customers receive a dedicated account manager, custom SLA, and direct phone/Slack support. All plans include access to our documentation and video tutorials.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-6 bg-white" data-id="element-42">
      <div className="max-w-3xl mx-auto" data-id="element-43">
        <div className="text-center mb-16" data-id="element-44">
          <h2 className="text-4xl font-bold text-slate-900 mb-4" data-id="element-45">
            Frequently asked questions
          </h2>
          <p className="text-xl text-slate-600" data-id="element-46">
            Everything you need to know about our platform
          </p>
        </div>

        <div className="space-y-4" data-id="element-47">
          {faqs.map((faq, index) => <div key={index} className="bg-slate-50 rounded-lg border border-slate-200 overflow-hidden" data-id="element-48">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-slate-100 transition-colors" data-id="element-49">
                <span className="font-semibold text-slate-900 pr-4" data-id="element-50">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-slate-500 flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-51" />
              </button>

              {openIndex === index && <div className="px-6 pb-5" data-id="element-52">
                  <p className="text-slate-600 leading-relaxed" data-id="element-53">{faq.answer}</p>
                </div>}
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-54">
          <p className="text-slate-600 mb-4" data-id="element-55">Still have questions?</p>
          <a href="https://calendly.com/alex-thruline/learn-about-thruline" target="_blank" rel="noopener noreferrer" className="text-blue-600 font-semibold hover:text-blue-700" data-id="element-56">
            Contact our team →
          </a>
        </div>
      </div>
    </section>;
}